var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',_vm._g(_vm._b({staticClass:"imd-sm-input imd-sm-select",attrs:{"outlined":"","dense":"","menu-props":{ offsetY: true, offsetOverflow: true, transition: 'scroll-y-transition' }}},'v-select',Object.assign({}, _vm.$attrs,
    {items: _vm.items_cp,
    value: _vm.value,
    itemValue: _vm.itemValue}),false),Object.assign({}, _vm.$listeners)))}
var staticRenderFns = []

export { render, staticRenderFns }